import { TextField, TextFieldProps } from "@mui/material";
import theme from "../../theme";

const getDetachedOutlinedStyles = (
  hasLabel: boolean,
  size?: string,
  isSelect?: boolean,
) => ({
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    top: "-23px",
    left: "4px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#3D3D3D",
  },
  "& .MuiInputBase-input": {
    marginTop: "16px",
  },
  "& .MuiOutlinedInput-root": {
    ...(isSelect
      ? {
          "& .MuiSelect-select": {
            marginTop: "0px",
            paddingTop: "16px",
            paddingBottom: "16px",
          },
        }
      : {
          input: {
            marginTop: "0px",
          },
        }),
    "&.Mui-disabled": {
      backgroundColor: `${theme.palette.gray[1]} !important`,
      borderRadius: "8px",
      "& fieldset": {
        border: "none",
      },
    },
    ...(size === "small" && {
      minHeight: "48px",
      height: "48px",
    }),
  },
  ...(size === "small" &&
    !isSelect && {
      input: {
        marginTop: "0px",
      },
    }),
  marginTop: hasLabel ? "23px" : "0px",
});

type CustomVariant = "detachedOutlined" | "outlined" | "filled" | "standard";

type TextFieldWrapperProps = Omit<TextFieldProps, "variant"> & {
  variant?: CustomVariant;
};

const TextFieldWrapper = ({
  variant,
  select,
  ...props
}: TextFieldWrapperProps) => {
  const isDetachedOutlined = variant === "detachedOutlined";

  const updatedProps: any = {
    ...props,
    select,
    variant: isDetachedOutlined ? "outlined" : variant,
  };

  const sx = isDetachedOutlined
    ? {
        ...getDetachedOutlinedStyles(!!props.label, props.size, select),
        ...props.sx, // Parent sx comes last to allow overrides
      }
    : props.sx;

  return <TextField {...updatedProps} sx={sx} />;
};

export default TextFieldWrapper;
